import React from 'react'

function Footer() {
    return (
        <>
            <div className="footer text-end">
                <p className="mb-0">
                    <img className="pe-2" src="/assets/images/login-footer-1.svg" alt="" height={"45px"} />
                    <img className="pe-2" src="/assets/images/sadc.png" alt="" height={"45px"} />
                    <img src="/assets/images/top-login-logo.svg" height={"45px"} alt="" />
                    <img className="mx-2" src="/assets/images/footer-2.png" height={"45px"} />
                    <img src="/assets/images/AICCRA.png" height={"45px"} alt="" />
                </p>
            </div>
        </>
    )
}

export default Footer